import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withKeys as _withKeys, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
import generateWeeksInMonth from '../../lib/generateWeeksInMonth';
import CalendarDay from './CalendarDay.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CalendarMonth',
    props: {
        disabledDates: { default: function (props) { var _a; return (_a = props.disabledDates) !== null && _a !== void 0 ? _a : []; } },
        month: { default: function (props) { var _a; return (_a = props.month) !== null && _a !== void 0 ? _a : new Date(); } },
        selectedRange: {},
        minDate: {},
        maxDate: {},
        range: { type: Boolean },
        allowDaysOutOfDisplayedMonth: { type: Boolean }
    },
    emits: ["day:clicked"],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        ;
        var selectDay = function (day) {
            var isDisabled = isDateDisabled(day.date, props.disabledDates, props.minDate, props.maxDate);
            if (!isDisabled) {
                emit('day:clicked', day);
            }
        };
        var weeks = computed(function () {
            return generateWeeksInMonth(props.month);
        });
        function getDaySelectedState(day, selectedRange) {
            var dateString = day.date.toDateString();
            var selectedRangeString = selectedRange.map(function (d) { return d === null || d === void 0 ? void 0 : d.toDateString(); });
            var returnValue = '';
            if (props.range && selectedRange[0]) {
                if (dateString === selectedRangeString[0]) {
                    returnValue = 'selected-range-start';
                }
                else if (selectedRange[1] && dateString === selectedRangeString[1]) {
                    returnValue = 'selected-range-end';
                }
                else if (selectedRange[1] && day.date > selectedRange[0] && day.date < selectedRange[1]) {
                    returnValue = 'selected-range';
                }
            }
            else if (selectedRange[0] && dateString === selectedRangeString[0]) {
                returnValue = 'selected';
            }
            return returnValue;
        }
        function isDateDisabled(date, disabledDates, minDate, maxDate) {
            return ((minDate && date < minDate) ||
                (maxDate && date > maxDate) ||
                disabledDates.some(function (d) { return d.toDateString() === date.toDateString(); }));
        }
        return function (_ctx, _cache) {
            return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weeks.value, function (week, index) {
                return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "week"
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week, function (day) {
                        return (_openBlock(), _createBlock(CalendarDay, {
                            key: day.date.getTime(),
                            day: day,
                            "is-disabled": isDateDisabled(day.date, _ctx.disabledDates, _ctx.minDate, _ctx.maxDate) || (!_ctx.allowDaysOutOfDisplayedMonth && !(day === null || day === void 0 ? void 0 : day.inDisplayedMonth)),
                            "day-selected-state": getDaySelectedState(day, _ctx.selectedRange),
                            "allow-days-out-of-displayed-month": !!_ctx.allowDaysOutOfDisplayedMonth,
                            onKeyup: _withKeys(function ($event) { return (selectDay(day)); }, ["enter"]),
                            onClick: function ($event) { return (selectDay(day)); }
                        }, {
                            default: _withCtx(function () { return [
                                _renderSlot(_ctx.$slots, "default", { day: day })
                            ]; }),
                            _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["day", "is-disabled", "day-selected-state", "allow-days-out-of-displayed-month", "onKeyup", "onClick"]));
                    }), 128 /* KEYED_FRAGMENT */))
                ]));
            }), 128 /* KEYED_FRAGMENT */));
        };
    }
});
